import type { FeaturesRepository } from "../repositories/features/features.repository";

export default class FeaturesService {
  constructor(private repo: FeaturesRepository) {
  }

  public getFeatures(brand?: string) {
    return this.repo.getFeatures(brand)
  }
}
